import type { MaskitoOptions, MaskitoPreprocessor } from '@maskito/core';
import {
    maskitoAddOnFocusPlugin,
    maskitoCaretGuard,
    maskitoPrefixPostprocessorGenerator,
    maskitoRemoveOnBlurPlugin,
} from '@maskito/kit';

const masks: Record<string, MaskitoOptions> = {
    password: {
        mask: [/\d/, /\d/, /\d/],
    },
    cpf: {
        mask: [
            /\d/, /\d/, /\d/, '.',
            /\d/, /\d/, /\d/, '.',
            /\d/, /\d/, /\d/, '-',
            /\d/, /\d/
        ],
    },
    cnpj: {
        mask: [
            /\d/, /\d/, '.',
            /\d/, /\d/, /\d/, '.',
            /\d/, /\d/, /\d/, '/',
            /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/
        ],
    },
    phone: {
        mask: [
            '(', /\d/, /\d/, ')', ' ',
            /\d/, /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/, /\d/, /\d/
        ],
    },
    date: {
        mask: [
            /\d/, /\d/, '/',
            /\d/, /\d/, '/',
            /\d/, /\d/, /\d/, /\d/
        ],
    },
    cep: {
        mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
    },
    ddi: {
        mask: ['+', /\d/, /\d/, /\d/],
    },
    ddd: {
        mask: [/\d/, /\d/, /\d/],
    },
};

function createCompletePhoneInsertionPreprocessor(): MaskitoPreprocessor {
    const trimPrefix = (value: string): string => value.replace(/^(\+?7?\s?8?)\s?/, '');
    const countDigits = (value: string): number => value.replaceAll(/\D/g, '').length;

    return ({ elementState, data }) => {
        const { value, selection } = elementState;

        return {
            elementState: {
                selection,
                value: countDigits(value) > 11 ? trimPrefix(value) : value,
            },
            data: countDigits(data) >= 11 ? trimPrefix(data) : data,
        };
    };
}

export { masks };